import { gql } from '@apollo/client';

export const ME_QUERY = gql`
  query Me {
    me {
      id
      name
      roles {
        name
        permissions {
          name
        }
      }
    }
  }
`;

export const DESIGNATIONS_OPTION_QUERY = gql`
  query Designations {
    designations(orderBy: { column: ORDER, order: ASC }) {
      id
      code
      name
      status
      order
    }
  }
`;

export const REGIONS_OPTION_QUERY = gql`
  query Regions {
    regions(orderBy: { column: ORDER, order: ASC }) {
      id
      name
      code
      status
      order
      locations {
        id
        name
        code
        status
      }
    }
  }
`;

export const LOCATIONS_OPTIONS_QUERY = gql`
  query Locations($userId: ID!) {
    locations(userId: $userId, orderBy: { column: ORDER, order: ASC }) {
      id
      name
      code
      status
      order
      region {
        id
        name
        code
        status
      }
    }
  }
`;

export const PORTFOLIO_OPTIONS_QUERY = gql`
  query Portfolios {
    portfolios(orderBy: { column: ORDER, order: ASC }) {
      id
      name
      code
      status
      order
    }
  }
`;

export const LEAVE_TYPE_OPTIONS_QUERY = gql`
  query LeaveTypes {
    leaveTypes(orderBy: { column: ORDER, order: ASC }) {
      id
      name
      code
      status
      order
    }
  }
`;

export const ALLOWANCE_TYPE_OPTIONS_QUERY = gql`
  query AllowanceTypes {
    allowanceTypes(orderBy: { column: ORDER, order: ASC }) {
      id
      name
      code
      status
      order
    }
  }
`;

export const DEDUCTION_TYPE_OPTIONS_QUERY = gql`
  query DeductionTypes {
    deductionTypes(orderBy: { column: ORDER, order: ASC }) {
      id
      name
      code
      status
      order
    }
  }
`;

export const PRODUCT_TYPE_OPTIONS_QUERY = gql`
  query ProductTypes {
    productTypes(orderBy: { column: ORDER, order: ASC }) {
      id
      name
      code
      status
      order
    }
  }
`;

export const STAGE_OPTIONS_QUERY = gql`
  query Stages {
    stages(orderBy: { column: ORDER, order: ASC }) {
      id
      name
      code
      status
      order
    }
  }
`;

export const CONVEYANCE_TYPE_OPTIONS_QUERY = gql`
  query ConveyanceType {
    conveyanceTypes(orderBy: { column: ORDER, order: ASC }) {
      id
      name
      code
      status
      order
    }
  }
`;

export const CATEGORIES_GET_QUERY = gql`
  query Categories($type: CategoryType!) {
    categories(type: $type, orderBy: { column: ORDER, order: ASC }) {
      ... on Designation {
        id
        name
        code
        status
        order
      }
      ... on Portfolio {
        id
        name
        code
        status
        order
      }
      ... on Region {
        id
        name
        code
        status
        order
      }
      ... on Location {
        id
        name
        code
        status
        order
        region {
          id
          name
          code
          order
        }
      }
      ... on LeaveType {
        id
        name
        code
        status
        order
      }
      ... on AllowanceType {
        id
        name
        code
        status
        order
      }
      ... on DeductionType {
        id
        name
        code
        status
        order
      }
      ... on ProductType {
        id
        name
        code
        status
        order
      }
      ... on Stage {
        id
        name
        code
        status
        order
      }
      ... on ConveyanceType {
        id
        name
        code
        status
        order
      }
    }
  }
`;

export const EMPLOYEE_LOOKUP_QUERY = gql`
  query EmployeeLookup($search: String, $status: String) {
    employeeLookup(search: $search, status: $status) {
      id
      first_name
      last_name
      emp_id
    }
  }
`;

export const EMPLOYEE_LOOKUP_BY_ROLECODE = gql`
  query EmployeesByRoleCode($roleCode: String, $status: String) {
    employeeByRoleCode(roleCode: $roleCode, status: $status) {
      id
      emp_id
      first_name
      last_name
    }
  }
`;

export const ROLE_PERMISSIONS_QUERY = gql`
  query RolePermissions {
    getRolePermissions {
      role_permissions {
        id
        name
        roles
      }
      roles {
        id
        name
      }
    }
  }
`;
